import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { SelectOptionList } from '../../components/option/SelectOptionList';
import { ScreenSize } from '../../api/ScreenSize';

export class SelectCatalogPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Background: {
        w: w => w,
        h: h => h,
        color: Theme.Colors.Option.Background.Page,
        alpha: 0.8,
        rect: true,
      },
      Options: {
        x: ScreenSize.w * 0.5,
        y: 0,
        mountX: 0.5,
        type: SelectOptionList,
      },
    };
  }

  _init() {
    let optionList = [];
    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i].name === this.selected) {
        optionList.push({ text: this.data[i].name, selected: true });
      } else {
        optionList.push({ text: this.data[i].name });
      }
    }

    this.tag('Options').data = { title: this.title, options: optionList, callback: this.cbFunc.bind(this) };
  }

  _getFocused() {
    return this.tag('Options');
  }

  _handleBack() {
    this.fireAncestors('$closeDialog');
  }

  cbFunc(val) {
    this.owner.updateSelected(val);
  }
}
